import { useEffect, useState } from 'react';

import Button from '../Button/Button';
import TableFilter from '../TableFilter/TableFilter';

import downloadIcon from '../../img/download-icon.svg';
import './ReportTable.scss';
import { useDispatch, useSelector } from 'react-redux';
import asyncGetList from '../../store/thunks/paycheck/asyncGetList';
import asyncPaycheckDownload from '../../store/thunks/paycheck/asyncPaycheckDownload';

const month = {
    1: 'Январь',
    2: 'Февраль',
    3: 'Март',
    4: 'Апрель',
    5: 'Май',
    6: 'Июнь',
    7: 'Июль',
    8: 'Август',
    9: 'Сентябрь',
    10: 'Октябрь',
    11: 'Ноябрь',
    12: 'Декабрь',
}

export default function ReportTable() {
    const year = useSelector(state => state.paycheck.year);
    const pdfList = useSelector(state => state.paycheck.pdfList);
    const message = useSelector(state => state.paycheck.message);
    const error = useSelector(state => state.paycheck.error);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(asyncGetList(year));
    }, [year]);

    const handlePaycheckDownload = (event) => {
        const month = parseInt(event.target.getAttribute('data-month'));
        
        dispatch(asyncPaycheckDownload({year, month}));
    }

    return (
        <div className="report-table">
            <TableFilter className="report-table__filter"/>
            <div className="report-table__items">
                { message && <p>{message}</p> }
                { error && <p style={{color: "red"}}>{error}</p> }
                { pdfList &&
                    pdfList.map((item, idx) => {
                        return(
                            <div className="report-table__item" key={idx}>
                                <p className="report-table__month">{month[item.month]}</p>
                                <Button className="btn report-table__download-btn" 
                                    data-month={item.month} 
                                    onClick={handlePaycheckDownload}
                                >
                                    <img src={downloadIcon} alt="download icon"/>
                                    Скачать
                                </Button>
                            </div>
                        )}
                    )
                }
            </div>
        </div>
    );
}